import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element not found in index.html");
}

// `import.meta.env.BASE_URL` is "/" for the public build/dev and "/private/"
// for the private bundle (`vite build --base=/private/`). React Router's
// `basename` must NOT carry a trailing slash, so strip it (but keep "/").
const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
